/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MessageViewDto } from './messageViewDto';


export interface ChatListItem { 
    id: string;
    type: ChatListItem.TypeEnum;
    name: string;
    avatarUrl: string;
    new_messages: number;
    nb_members: number;
    last_message?: MessageViewDto;
    lastUnreadMessageTime?: string;
    haveOneOrMoreUserActive: boolean;
    createdAt: string;
}
export namespace ChatListItem {
    export type TypeEnum = 'event' | 'group' | 'smatcher';
    export const TypeEnum = {
        Event: 'event' as TypeEnum,
        Group: 'group' as TypeEnum,
        Smatcher: 'smatcher' as TypeEnum
    };
}


